import React, { useEffect, useState } from "react";
import InputTextSimple from "../../../../components/common/InputText/InputTextSimple";
import CheckBoxWithOutLabel from "../../../../components/common/checkbox/CheckboxWithoutLabel";
import ButtonOutlineFluid from "../../../../components/common/buttons/ButtonOutlineFluid";
import ButtonFluid from "../../../../components/common/buttons/ButtonFluid";
import Items from ".//..//..//..//..//assets//images//icons//items.svg";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "../../../../constants/Routes";
import ItemProfileModal from "./ItemProfileModal";
import HttpHelper from "../../../../helpers/Http/HttpHelper";
import { API_ROUTES } from "../../../../constants/API_ROUTES";
import useAuth from "../../../../hooks/useAuth";
import { toast } from "react-toastify";
import InputNumbersSimple from "../../../../components/common/InputText/InputNumbersSimple";
import Swal from "sweetalert2";

const ItemProfile = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const { getAuth, clearAuth } = useAuth();

  const zoneId = queryParams.get("zone-id");
  const zoneItemId = queryParams.get("zone-item-id");
  const [zoneName, setZoneName] = useState("");

  const fetchData = () => {
    HttpHelper.GetRequest({
      route: `${API_ROUTES.ZONE_ITEMS_DATA}`,
      id: zoneItemId,
      token: getAuth()?.bearerToken,
    })
      .then((res) => {
        const zoneItem = res?.data?.zone;
        console.log(zoneItem);
        setTargyNeve(zoneItem?.targy_neve);
        setVillanyszerelo(zoneItem?.villanyszerelo);
        setKonyhaszerelo(zoneItem?.konyhaszerelo);
        setDubelArbeiten(zoneItem?.dubel_arbeiten);
        setVolume(zoneItem?.volume);
        setZoneName(zoneItem?.zone?.nev);
        setCsomagolasiIdo(zoneItem?.csomagolasi_ido);
        setBuborekcsomagolasiIdo(zoneItem?.buborekcsomagolasi_ido);
        setKicsomagolasiIdo(zoneItem?.kicsomagolasi_ido);
        setSzetszerelesiIdo(zoneItem?.szetszerelesi_ido);
        setOsszeszerelesiIdo(zoneItem?.osszeszerelesi_ido);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const refresh = () => {
    fetchData();
  };

  useEffect(() => {
    fetchData();
  }, []);

  const navigate = useNavigate();
  //Item Name
  const [targyNeve, setTargyNeve] = useState("");
  const [targyNeveError, setTargyNeveError] = useState("");
  //Electricians
  const [villanyszerelo, setVillanyszerelo] = useState(false);
  const [villanyszereloError, setVillanyszereloError] = useState("");
  //Kitchen Fitter
  const [konyhaszerelo, setKonyhaszerelo] = useState(false);
  const [konyhaszereloError, setKonyhaszereloError] = useState(false);
  //Dübel Arbeiten
  const [dubelArbeiten, setDubelArbeiten] = useState(false);
  const [dubelArbeitenError, setDubelArbeitenError] = useState(false);
  //Volumen
  const [volume, setVolume] = useState(0);
  const [volumeError, setVolumeError] = useState("");
  //Csomagolási idő /fő
  const [csomagolasiIdo, setCsomagolasiIdo] = useState(0);
  const [csomagolasiIdoError, setCsomagolasiIdoError] = useState("");
  //Buborékcsomagolási idő /fő
  const [buborekcsomagolasiIdo, setBuborekcsomagolasiIdo] = useState(0);
  const [buborekcsomagolasiIdoError, setBuborekcsomagolasiIdoError] = useState("");

  //Kicsomagolási idő /fő
  const [kicsomagolasiIdo, setKicsomagolasiIdo] = useState(0);
  const [kicsomagolasiIdoError, setKicsomagolasiIdoError] = useState("");

  //Szétszerelési idő /fő
  const [szetszerelesiIdo, setSzetszerelesiIdo] = useState(0);
  const [szetszerelesiIdoError, setSzetszerelesiIdoError] = useState("");

  //Összeszerelési idő /fő
  const [osszeszerelesiIdo, setOsszeszerelesiIdo] = useState(0);
  const [osszeszerelesiIdoError, setOsszeszerelesiIdoError] = useState("");

  const handleDeleteClick = (zoneItemId) => {
    const zoneItemsId = zoneItemId;
    const token = getAuth()?.bearerToken;
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger",
      },
      buttonsStyling: false,
    });
    swalWithBootstrapButtons
      .fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel!",
        confirmButtonColor: "#8CD4F5",
        cancelButtonColor: "#eee",
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          HttpHelper.DeleteRequest({
            route: API_ROUTES.ZONE_ITEMS_DELETE,
            id: zoneItemsId,
            token: token,
          })
            .then((result) => {
              if (result.status == 200) {
                navigate(`${ROUTES.ADMIN_ZONE_ITEMS}?zone-id=${zoneId}`);
                toast.success("Zone item successfully removed !", {
                  position: "top-right",
                  autoClose: 2000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "light",
                });
              } else if (result.status == 404) {
                toast.error("API not found !", {
                  position: "top-right",
                  autoClose: 2000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "light",
                });
              } else if (result.status == 500) {
                toast.error("Server error !", {
                  position: "top-right",
                  autoClose: 2000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "light",
                });
              } else {
                toast.error("Unknown server error !", {
                  position: "top-right",
                  autoClose: 2000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "light",
                });
              }
            })
            .catch((error) => {
              toast.error("Unknown server error !", {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              });
            });
        } else if (
          /* Read more about handling dismissals below */
          result.dismiss === Swal.DismissReason.cancel
        ) {
          swalWithBootstrapButtons.fire({
            title: "Cancelled",
            text: "Zone is safe :)",
            icon: "error",
          });
        }
      });
  };

  return (
    <>
      <div className="px-[1rem] sm:px-[1.875rem] mt-[3rem]">
        <div className=" mt-[3rem]  flex flex-row justify-between items-center ">
          <div className="flex flex-row items-center gap-[1rem] sm:gap-[1.875rem]">
            <Link to={`${ROUTES.ADMIN_ZONE_ITEMS}?zone-id=${zoneId}`}>
              <i className="bg-[rgba(6,85,103,0.5)] min-h-[4.3rem] min-w-[4.3rem] rounded-full flex justify-center items-center">
                <img src={Items} alt="items icon" className="w-[2.5rem] " />
              </i>
            </Link>
            <div>
              <h2 className="font-bold font-lato text-[2rem] sm:text-[3.125rem] leading-normal">{targyNeve}</h2>
              <p className="text-[#BDBDBD] text-[1rem] font-bold font-lato">{zoneName}</p>
            </div>
          </div>
          <div className="mt-[1.6rem] gap-5 flex flex-row w-[20rem] text-center">
            {/* <Link to={ROUTES.ADMIN_ZONE_MANAGE}></Link> */}
            <ItemProfileModal
              zoneId={zoneId}
              zoneItemId={zoneItemId}
              p_targyNeve={targyNeve}
              p_villanyszerelo={villanyszerelo}
              p_konyhaszerelo={konyhaszerelo}
              p_dubelArbeiten={dubelArbeiten}
              p_volume={volume}
              p_csomagolasiIdo={csomagolasiIdo}
              p_buborekcsomagolasiIdo={buborekcsomagolasiIdo}
              p_kicsomagolasiIdo={kicsomagolasiIdo}
              p_szetszerelesiIdo={szetszerelesiIdo}
              p_osszeszerelesiIdo={osszeszerelesiIdo}
              refresh={refresh}
            />
            <ButtonOutlineFluid
              label={`Tétel törlése`}
              onClick={() => {
                handleDeleteClick(zoneItemId);
              }}
            />
          </div>
        </div>
        {/* Header Start */}
        <div className="mt-[3rem] flex flex-row  justify-between gap-4 ">
          <div className="w-full lg:w-1/2">
            <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
              <label className="text-[1rem] w-[12rem]  font-lato font-normal leading-normal">Tárgy neve</label>
              <InputTextSimple
                placeholder={``}
                variant="light"
                value={targyNeve}
                error={targyNeveError}
                readOnly={true}
              />
            </div>
            <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
              <label className="text-[1rem] w-[12rem]  font-lato font-normal leading-normal">Villanyszerelő</label>
              <CheckBoxWithOutLabel
                value={villanyszerelo}
                checked={villanyszerelo}
                name={"villanyszerelo"}
                id={"villanyszerelo"}
                error={villanyszereloError}
                readOnly={true}
              />
            </div>
            <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
              <label className="text-[1rem] w-[12rem]   font-lato font-normal leading-normal">Konyhaszerelő</label>
              <CheckBoxWithOutLabel
                checked={konyhaszerelo}
                value={konyhaszerelo}
                id={`konyhaszerelo`}
                name={`konyhaszerelo`}
                error={konyhaszereloError}
                readOnly={true}
              />
            </div>
            <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
              <label className="text-[1rem] w-[12rem] font-lato font-normal leading-normal">Dübel Arbeiten</label>
              <CheckBoxWithOutLabel
                checked={dubelArbeiten}
                value={dubelArbeiten}
                id={`dubelArbeiten`}
                name={`dubelArbeiten`}
                error={dubelArbeitenError}
                readOnly={true}
              />
            </div>

            <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
              <label className="text-[1rem] w-[12rem] font-lato font-normal leading-normal">Volumen (m3)</label>
              <InputNumbersSimple
                placeholder={``}
                variant="light"
                id={"volume"}
                name={"volume"}
                value={volume}
                error={volumeError}
                readOnly={true}
              />
            </div>
            <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
              <label className="text-[1rem] w-[12rem] font-lato font-normal leading-normal">Csomagolási idő /fő</label>
              <InputNumbersSimple
                placeholder={``}
                variant="light"
                id={"csomagolasiIdo"}
                name={"csomagolasiIdo"}
                value={csomagolasiIdo}
                error={csomagolasiIdoError}
                readOnly={true}
              />
            </div>
            <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
              <label className="text-[1rem] w-[12rem] font-lato font-normal leading-normal">
                Buborékcsomagolási idő /fő
              </label>
              <InputNumbersSimple
                placeholder={``}
                variant="light"
                id={"buborekcsomagolasiIdo"}
                name={"buborekcsomagolasiIdo"}
                value={buborekcsomagolasiIdo}
                error={buborekcsomagolasiIdoError}
                readOnly={true}
              />
            </div>
            <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
              <label className="text-[1rem] w-[12rem] font-lato font-normal leading-normal">
                Kicsomagolási idő /fő
              </label>
              <InputNumbersSimple
                placeholder={``}
                variant="light"
                id={"kicsomagolasiIdo"}
                name={"kicsomagolasiIdo"}
                value={kicsomagolasiIdo}
                error={kicsomagolasiIdoError}
                readOnly={true}
              />
            </div>
            <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
              <label className="text-[1rem] w-[12rem] font-lato font-normal leading-normal">
                Szétszerelési idő /fő
              </label>
              <InputNumbersSimple
                placeholder={``}
                variant="light"
                id={"szetszerelesiIdo"}
                name={"szetszerelesiIdo"}
                value={szetszerelesiIdo}
                error={szetszerelesiIdoError}
                readOnly={true}
              />
            </div>
            <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
              <label className="text-[1rem] w-[12rem] font-lato font-normal leading-normal">
                Összeszerelési idő /fő
              </label>
              <InputNumbersSimple
                placeholder={``}
                variant="light"
                id={"osszeszerelesiIdo"}
                name={"osszeszerelesiIdo"}
                value={osszeszerelesiIdo}
                error={osszeszerelesiIdoError}
                readOnly={true}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ItemProfile;
